<mat-form-field *ngIf="(allowedTenants$ | async) as tenants">
  <mat-label>Agency</mat-label>
  <mat-select [value]="tenant$ | async" (selectionChange)="handleTenantChange($event)">
    <mat-option *ngFor="let tenant of tenants | keyvalue" [value]="tenant.key">
      {{ tenant.key | uppercase }}
    </mat-option>
  </mat-select>
</mat-form-field>
